<template>
  <div class="flex-col page">
    <div class="flex-col items-center self-stretch">
      <img
        class="image"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=51bcc5b5455eb455b1d1899933aca06f.png"
      />
      <span class="mt-12 text">保险小A</span>
    </div>
    <div class="flex-col self-stretch group">
      <div class="flex-row justify-between section">
        <span class="self-start font text_2">个人信息</span>
        <img
          class="self-center image_2"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=db9902cb17eec4a08d2888b6918bd53a.png"
        />
      </div>
      <div class="mt-20 flex-row justify-between section">
        <span class="self-start font">设置</span>
        <img
          class="self-center image_2"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=db9902cb17eec4a08d2888b6918bd53a.png"
        />
      </div>
    </div>

    <div class="flex-row self-stretch relative bottom">
      <div class="section_10"></div>
      <div class="flex-col shrink-0 section_12 pos_6">
        <div class="flex-row justify-between">
          <img
            @click="$router.push('/shouye')"
            class="image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=599f1a3f7b185b6144b6fffae0e7851f.png"
          />
          <img
            @click="$router.push('/xiangce')"
            class="image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=583c5fb06c92fb3306dfd6d4a531c8b8.png"
          />
          <img
            class="image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=05d6106d0be32ef7e9f1f0f4532ec855.png"
          />
        </div>
        <div class="mt-4 flex-row justify-between">
          <span class="font_5 text_13">主页</span>
          <span class="font_5">相册</span>
          <span class="font_5">我的</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {};
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .page {
    padding: 103px 24px 30px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .image {
      width: 180px;
      height: 180px;
    }
    .text {
      color: rgb(255, 255, 255);
      font-size: 24px;
      font-family: Barlow;
      font-weight: 600;
      line-height: 22.5px;
    }
    .group {
      margin-top: 82px;
      .section {
        padding: 20px 24px 20px 32px;
        background-color: rgb(28, 28, 28);
        border-radius: 30px;
        .font {
          font-size: 18px;
          font-family: Barlow;
          line-height: 16px;
          color: rgb(255, 255, 255);
        }
        .text_2 {
          line-height: 16.5px;
        }
        .image_2 {
          width: 24px;
          height: 24px;
        }
      }
    }
    .equal-division {
      position: relative;
      align-self: center;
      margin-top: 206px;
      .group_2 {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        .text_3 {
          line-height: 9px;
        }
      }
      .equal-division-item {
        padding: 4px 0;
        width: 92.5px;
      }
      .image_3 {
        width: 25px;
        height: 25px;
      }
      .font_2 {
        font-size: 10px;
        font-family: Nunito;
        line-height: 9px;
        color: rgb(166, 166, 166);
      }
      .group_3 {
        position: absolute;
        right: 6.5px;
        top: 50%;
        transform: translateY(-50%);
        .text_4 {
          color: rgb(46, 5, 5);
        }
      }
    }
    .bottom {
      position: fixed;
      bottom: -76px;
      .section_10 {
        flex: 1 1 163px;
        border-radius: 16px;
        overflow: hidden;
        height: 204px;
      }
      .section_11 {
        margin-left: 16px;
        margin-right: 20px;
        flex: 1 1 163px;
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 16px 16px 0 0;
        overflow: hidden;
        height: 204px;
        .image-wrapper {
          border-radius: 16px;
          overflow: hidden;
          background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=8d77d3e05f086dca95b84a4b56e9e0de.png');
          background-position: 0% 0%;
          background-size: 100%, 100%;
          background-repeat: no-repeat;
          .image_3 {
            width: 162px;
            height: 204px;
          }
        }
      }
      .image_2 {
        border-radius: 16px;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.05);
        width: 163px;
        height: 204px;
      }
      .pos_5 {
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .section_12 {
        padding: 8px 40px 12px;
        background-color: rgb(255, 255, 255);
        border-radius: 32px;
        filter: drop-shadow(-2px 4px 2px #8c8c8c26);
        width: 289px;
        .image_4 {
          width: 24px;
          height: 24px;
        }
        .font_5 {
          font-size: 10px;
          font-family: Nunito;
          line-height: 9px;
          color: rgb(166, 166, 166);
        }
        .text_13 {
          color: rgb(46, 5, 5);
          line-height: 9px;
        }
      }
      .pos_6 {
        position: absolute;
        left: 26.5px;
        top: 41px;
      }
    }
    .section_2 {
      padding: 2px 6px 8px;
      background-color: rgb(255, 255, 255);
      border-radius: 32px;
      filter: drop-shadow(-2px 4px 2px #8c8c8c26);
      width: 289px;
    }
  }
</style>
